/**
 * @file Allow using app feature flags
 */
import environment from '@@/bits/environment'
import window from '@@/bits/global'
import { isStringTruthy } from '@@/bits/truthy'

type CurrentFlags =
  | 'debugFrontend'
  | 'goldPlansVisible'
  | 'surfaceSections'
  | 'managePeopleV2'
  | 'postClickExperiment'
  | 'mentions'
  | 'aiImageSearch'
  | 'googleDrive'
  | 'accumulatedReactions'
  | 'makeAPadletV2'
  | 'realtimeFetching'
  | 'surfaceGroupByPanel'
  | 'reportButton'
  | 'magicPadlet'
  | 'zoom'
  | 'spreadsheetExportsV2'
  | 'slideshowSharePanel'
  | 'surfacePoll'
  | 'backpackAdmin'
  | 'dashboardNavigation'
  | 'teamGoldTrial'
  | 'subscriptionsPage'
  | 'remakeSettingV2'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const flip = ww.flip || ww.vueStartingState?.flip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

export const isDebugMode =
  environment === 'development' ||
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  isStringTruthy(new URLSearchParams(window.location.search).get('ww_debug'))

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

export { isAppUsing }
